import request from '@/shared/utils/request';
import type {
  QuickWithdrawConfigParams,
  QuickWithdrawConfigData,
} from './types';

/**
 * 快速提现接口
 * @yapi f.loan.quick.withdraw
 * @description 快速提现接口 https://yapi.hellobike.cn/project/3415/interface/api/403089
 * @param params 请求参数
 * @return 返回值
 */
export const getQuickWithdrawConfig = async (
  params: QuickWithdrawConfigParams,
): Promise<QuickWithdrawConfigData | undefined> => request.postGate(
  'f.loan.quick.withdraw',
  params as Record<string, unknown>,
  { showLoading: undefined },
);


/**
 * 快速弹窗展示成功
 * @yapi f.loan.quick.pop.show
 * @description 快速弹窗展示成功 https://yapi.hellobike.cn/project/3415/interface/api/409993
 * @return 返回值
 */
export const reportQuickPopShow = async (): Promise<boolean> => request.postGate(
  'f.loan.quick.pop.show',
  {},
  {
    showLoading: undefined,
  },
);
